import { jsx as _jsx } from "react/jsx-runtime";
import cx from 'classnames';
import { CatButton } from '@blocks-react/components/Button';
import { CatIconSearch } from '@blocks-react/components/Icons/Search';
import styles from './HeaderEquipmentSearchIcon.module.scss';
export const HeaderEquipmentSearchIcon = ({ isSearchBarInHeader, ...buttonProps }) => (_jsx(CatButton, { slot: "custom", variant: "primary", hideText: true, className: cx(styles['searchIcon'], {
        [styles['searchIcon__search-banner']]: !isSearchBarInHeader,
        [styles['searchIcon__non-search-banner']]: isSearchBarInHeader
    }), "data-testid": "header-search-button", ...buttonProps, children: _jsx(CatIconSearch, { slot: "before" }) }));
